import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiClientConfig} from '../api-client-config';
import {ItemDocDependency} from '@primatoo-ms-organization';
import {DeleteEntityServiceInterface} from '../interface/delete-entity-service-interface';
import { ImportDataService } from '../interface/import-data-service';

import {ApiClientUtils} from '../../api-client.utils';
import {DownloadFormat} from '@pt/pt-models';
import { Attachment } from 'it/primatoo/openapi/api/org/schemas/common/Attachment';
import { AttachmentType } from 'it/primatoo/openapi/api/org/schemas/common/AttachmentType';

@Injectable({
  providedIn: 'root'
})
export class AttachmentsService extends ImportDataService implements DeleteEntityServiceInterface {
  private readonly endpointAttachment: string;

  constructor(
    @Inject(ApiClientConfig) private config: ApiClientConfig,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpointAttachment = this.config.endPoint + '/api/org/attachments/';
  }

  public uploadAttachment(file: File): Observable<any> {
    const url = this.endpointAttachment + `upload`;
    const formData = new FormData();
    if (file) {
      formData.append('file', file, file.name);
    }
    const uploadRequest = new HttpRequest('POST', url, formData, {reportProgress: true});
    return this.httpClient.request<void>(uploadRequest);
  }

  public getAttachmentById(id: number): Observable<Attachment> {
    const url = this.endpointAttachment + id + '/';
    return this.httpClient.get<Attachment>(url);
  }

  public getAttachmentByUuids(attachmentsUuid: number[]): Observable<Attachment[]> {
    let url = this.endpointAttachment + 'by-uuids';
    if (attachmentsUuid?.length > 0) {
      url += `?${ApiClientUtils.buildAttachmentsUuidFilter(attachmentsUuid)}`;
    }
    return this.httpClient.get<Attachment[]>(url);
  }

  public downloadAttachment(attachment: Attachment, type: AttachmentType) {
    const url = this.endpointAttachment + attachment.id + '/download';
    switch (type) {
      case AttachmentType.PDF:
        ApiClientUtils.downloadComplete(
          this.httpClient,
          url,
          DownloadFormat.PDF,
          attachment.name
        );
        break;
      // case AttachmentType.ZIP:
      //   ApiClientUtils.downloadComplete(this.httpClient, url, DownloadFormat.ZIP);
      //   break;
      case AttachmentType.DOC:
        ApiClientUtils.downloadComplete(
          this.httpClient,
          url,
          DownloadFormat.DOC,
          attachment.name
        );
        break;
      case AttachmentType.DOCX:
        ApiClientUtils.downloadComplete(
          this.httpClient,
          url,
          DownloadFormat.DOCX,
          attachment.name
        );
        break;
      case AttachmentType.ODT:
        ApiClientUtils.downloadComplete(
          this.httpClient,
          url,
          DownloadFormat.ODT,
          attachment.name
        );
        break;
      case AttachmentType.TXT:
        ApiClientUtils.downloadComplete(
          this.httpClient,
          url,
          DownloadFormat.TXT,
          attachment.name
        );
        break;
      case AttachmentType.CSV:
        ApiClientUtils.downloadComplete(
          this.httpClient,
          url,
          DownloadFormat.CSV,
          attachment.name
        );
        break;
      case AttachmentType.ODS:
        ApiClientUtils.downloadComplete(
          this.httpClient,
          url,
          DownloadFormat.ODS,
          attachment.name
        );
        break;
      case AttachmentType.XLS:
        ApiClientUtils.downloadComplete(
          this.httpClient,
          url,
          DownloadFormat.XLS,
          attachment.name
        );
        break;
      case AttachmentType.XLSX:
        ApiClientUtils.downloadComplete(
          this.httpClient,
          url,
          DownloadFormat.XLSX,
          attachment.name
        );
        break;
      case AttachmentType.PPT:
        ApiClientUtils.downloadComplete(
          this.httpClient,
          url,
          DownloadFormat.PPT,
          attachment.name
        );
        break;
      case AttachmentType.PPTX:
        ApiClientUtils.downloadComplete(
          this.httpClient,
          url,
          DownloadFormat.PPTX,
          attachment.name
        );
        break;
      case AttachmentType.ODP:
        ApiClientUtils.downloadComplete(
          this.httpClient,
          url,
          DownloadFormat.ODP,
          attachment.name
        );
        break;
      case AttachmentType.PNG:
        ApiClientUtils.downloadComplete(
          this.httpClient,
          url,
          DownloadFormat.PNG,
          attachment.name
        );
        break;
      case AttachmentType.JPG:
        ApiClientUtils.downloadComplete(
          this.httpClient,
          url,
          DownloadFormat.JPG,
          attachment.name
        );
        break;
      case AttachmentType.JPEG:
        ApiClientUtils.downloadComplete(
          this.httpClient,
          url,
          DownloadFormat.JPEG,
          attachment.name
        );
        break;
      case AttachmentType.P7M:
        ApiClientUtils.downloadComplete(
          this.httpClient,
          url,
          DownloadFormat.P7M,
          attachment.name
        );
        break;
    }
  }


  getEndPointV1(): string {
    return this.endpointAttachment;
  }

  public delete(id: number): Observable<void> {
    const url = this.endpointAttachment + id + '/';
    return this.httpClient.delete<void>(url);
  }

  public getDocDependencies(id: number): Observable<ItemDocDependency[]> {
    const url = this.getEndPointV1() + `${id}/doc-dependencies/`;
    return this.httpClient.get<ItemDocDependency[]>(url);
  }

  deleteMultiple(ids: number[]): Observable<{ failed: number[] }> {
    return undefined;
  }
}
